export enum Permission {
  ReadStatistics = 'read:statistics',

  ReadSale = 'read:sale',
  ReadWriteSale = 'readwrite:sale',

  ReadCrediPago = 'read:crediPago',
  ReadWriteCrediPago = 'readwrite:crediPago',

  ReadCustomer = 'read:customer',
  ReadWriteCustomer = 'readwrite:customer',

  ReadCompany = 'read:company',
  ReadWriteCompany = 'readwrite:company',
  FullControlCompany = 'fullcontrol:company',

  ReadBranch = 'read:branch',
  ReadWriteBranch = 'readwrite:branch',
  FullControlBranch = 'fullcontrol:branch',

  ReadWarehouse = 'read:warehouse',
  ReadWriteWarehouse = 'readwrite:warehouse',
  FullControlWarehouse = 'fullcontrol:warehouse',

  ReadPointsOfSale = 'read:pointsOfSale',
  ReadWritePointsOfSale = 'readwrite:pointsOfSale',
  FullControlPointsOfSale = 'fullcontrol:pointsOfSale',

  ReadCoupon = 'read:coupon',
  ReadWriteCoupon = 'readwrite:coupon',
  FullControlCoupon = 'fullcontrol:coupon',

  ReadPromotion = 'read:promotion',
  ReadWritePromotion = 'readwrite:promotion',
  FullControlPromotion = 'fullcontrol:promotion',

  ReadUser = 'read:user',
  ReadWriteUser = 'readwrite:user',
  FullControlUser = 'fullcontrol:user',

  ReadRole = 'read:role',
  ReadWriteRole = 'readwrite:role',
  FullControlRole = 'fullcontrol:role',

  ReadCashClosing = 'read:cashClosing',
  ReadWriteCashClosing = 'readwrite:cashClosing',

  ReadCatalog = 'read:catalog',
  ReadWriteCatalog = 'readwrite:catalog',
  FullControlCatalog = 'fullcontrol:catalog',
  RetireItemCatalog = 'retireitem:catalog',

  ReadDiscount = 'read:discount',
  ReadWriteDiscount = 'readwrite:discount',
  FullControlDiscount = 'fullcontrol:discount',

  ReadFreight = 'read:freight',
  ReadWriteFreight = 'readwrite:freight',
  FullControlFreight = 'fullcontrol:freight',

  ReadZone = 'read:zone',
  ReadWriteZone = 'readwrite:zone',
  FullControlZone = 'fullcontrol:zone',

  ReadSuggestedPrice = 'read:suggestedPrice',
  ReadWriteSuggestedPrice = 'readwrite:suggestedPrice',
  FullControlSuggestedPrice = 'fullcontrol:suggestedPrice',

  ControlKardexReport = 'fullcontrol:kardexReport',

  ReadOrganization = 'read:organization',
  ReadWriteOrganization = 'readwrite:organization',
  FullControlOrganization = 'fullcontrol:organization',
}
